import { ThemeToggle } from "./ThemeToggle";

export function Header() {
  return (
    <header className="w-full">
      <ThemeToggle />
    </header>
  );
}
